<template>
    <div>

        <Editor
            :key="needReload"
            :id="props.id"
            v-model="descriptionVal"
            :editorStyle="`height: ${props.height}`"
            :readonly="props.readonly"
            :placeholder="props.placeholder"
            @text-change="onTextChange"
            :class="{ 'invalid-editor': props.errorMessage ?? false }"
            @load="editorLoaded"
        >
            <template #toolbar>
                <div v-if="props.hideToolbar" class="ql-formats"></div>
                <div v-else>
                    <span class="ql-formats">
                        <button class="ql-bold"></button>
                        <button class="ql-italic"></button>
                        <button class="ql-underline"></button>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                    </span>
                    <span class="ql-formats">
                        <!--<button class="ql-link"></button>-->
                        <button class="ql-link" @click="showLinkDialog"></button>
                        <button class="ql-clean"></button>
                    </span>
                </div>
            </template>
        </Editor>
        <small class="p-invalid" v-if="props.errorMessage">{{ props.errorMessage }}</small>

        <Dialog header="Insert Link" v-model:visible="linkDialogVisible">
            <div class="p-fluid">
                <div class="p-field">
                    <label for="linkText">Text</label>
                    <InputText id="linkText" v-model="linkText" />
                </div>
                <div class="p-field">
                    <label for="linkUrl">URL</label>
                    <InputText id="linkUrl" v-model="linkUrl" />
                </div>
                <div class="p-d-flex p-jc-end">
                    <Button label="Cancel" icon="pi pi-times" @click="linkDialogVisible = false" class="p-button-text" />
                    <Button label="Insert" icon="pi pi-check" @click="insertLink" />
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script setup>
import { defineEmits, defineProps, onMounted, ref } from 'vue';

const emit = defineEmits(['update:modelValue', 'text-change']);
const props = defineProps({
    id: {
        type: String,
    },
    modelValue: {
        type: String,
    },
    placeholder: {
        type: String,
    },
    readonly: {
        type: Boolean,
    },
    errorMessage: {
        type: String,
    },
    hideToolbar: {
        type: Boolean,
        default: false,
    },
    height: {
        type: String,
        default: '150px',
    },
});

const descriptionVal = ref(null);
const linkDialogVisible = ref(false)
const linkText = ref("")
const linkUrl = ref("")
const needReload = ref(1)
const savedRange = ref(null)

onMounted(() => {

    if (props.modelValue) {
        descriptionVal.value = props.modelValue;
    }
});

function onTextChange() {
    emit('update:modelValue', descriptionVal.value)
}

function showLinkDialog() {
    const quill = editorInstanceClipboard.value?.quill;
    if (quill) {
        savedRange.value = quill.getSelection() || quill.selection?.savedRange || null;
    }
    linkDialogVisible.value = true;
}

const editorInstanceClipboard = ref(null)

function editorLoaded(event) {
    editorInstanceClipboard.value = event.instance.clipboard;
}

function insertLink() {

    const quill = editorInstanceClipboard.value.quill;

    const range = savedRange.value || quill.getSelection();
    const index = range && range.index != null ? range.index : quill.getLength();
    const length = range && range.length ? range.length : 0;

    if (length > 0) {
        quill.deleteText(index, length, 'user');
    }
    quill.insertText(index, linkText.value, 'link', linkUrl.value, 'user');
    quill.setSelection(index + linkText.value.length, 0, 'user');

    linkDialogVisible.value = false;
    linkText.value = '';
    linkUrl.value = '';
    savedRange.value = null;
}

</script>

<style>
.invalid-editor {
    border: 1px solid #f44336;
}
</style>
